/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const initSGCheckout = function () {
  if (typeof SmartOrderRefillSettings === 'undefined') return;

  if (SmartOrderRefillSettings.hasSORProducts) {
    $('.pt_checkout .billing-coupon-code').parent().hide();
  }
  $('.cart-row .refillInfo').each(function () {
    if ($(this).parent('.item-details').find('.item-edit-details').length === 0) {
      let url = window.Urls.getProductUrl + '?source=cart';
      const quantity = $(this).parents('.cart-row').find('.item-quantity input').val();
      const id = $(this).parents('.cart-row').find('.sku .value').text().trim();
      const uuid = $(this).parents('.cart-row').data('uuid');
      url += '&Quantity=' + quantity;
      url += '&uuid=' + uuid;
      url += '&pid=' + id;
      $(`<div class="item-edit-details">
            <a href="${url}" title="">Edit Details</a>
            </div>`).insertBefore($(this));
    }
  });
};

module.exports = {
  initSGCheckout: initSGCheckout
};
